export default __webpack_public_path__ + "static/media/4937.39e7886e.png";